/**
 * change-password-fields.js
 */

import React from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { passwordValidationRules, passwordConfirmValidationRules } from 'utils/user-profile-validation';
import TextField from 'components/form-inputs/text-field';
import FormGridItem from 'components/menu-drawer/form-grid-item';


export default function ChangePasswordFields(props) {
  const { allowEmpty } = props;
  const { t } = useTranslation('profileEdit');
  const newPassword = useWatch({ name: 'newPassword' });


  const newPasswordField = (
    <TextField
      name="newPassword"
      label={t('passwordReset.newPassword.label')}
      type="password"
      autoComplete="new-password"
      rules={passwordValidationRules(
        allowEmpty,
        t('passwordReset.newPassword.errMsgEmpty'),
        t('passwordReset.newPassword.errMsgPattern'),
        t('errMsgMinLength', { minLength: '8' }),
        t('errMsgLength', { maxLength: '20' })
      )}
    />
  );


  const confirmPasswordField = (
    <TextField
      name="confirmPassword"
      label={t('passwordReset.confirmPassword.label')}
      type="password"
      autoComplete="new-password"
      rules={passwordConfirmValidationRules(
        allowEmpty,
        newPassword,
        t('passwordReset.confirmPassword.errMsgEmpty'),
        t('passwordReset.confirmPassword.errMsgMismatch')
      )}
    />
  );


  return (
    <>
      <FormGridItem>
        {newPasswordField}
      </FormGridItem>
      <FormGridItem>
        {confirmPasswordField}
      </FormGridItem>
    </>
  );
}